import React, { useState, useEffect } from "react";
import axios from "axios";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import {
  ServicesContainer,
  ServicesH1,
  ServicesWrapper,
  ServicesCard,
  ServicesIcon,
} from "./GalleryElements";
import styled from "styled-components";

const ControlsBar = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  margin-bottom: 30px;
  flex-wrap: wrap;

  @media screen and (max-width: 768px) {
    gap: 10px;
  }
`;

const ControlLabel = styled.label`
  color: #fff;
  font-size: 1rem;
  font-weight: 500;
`;

const Select = styled.select`
  padding: 8px 15px;
  border-radius: 5px;
  border: 1px solid #fff;
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
  font-size: 1rem;
  cursor: pointer;
  outline: none;

  &:hover {
    background: rgba(255, 255, 255, 0.2);
  }

  option {
    background: #010606;
    color: #fff;
  }
`;

const ImageCard = styled(ServicesCard)`
  cursor: pointer;
  transition: transform 0.3s ease;

  &:hover {
    transform: scale(1.05);
  }
`;

const Gallery = () => {
  const [images, setImages] = useState([]);
  const [displayLimit, setDisplayLimit] = useState(6);
  const [sortOrder, setSortOrder] = useState("ASC");
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);
  const baseUrl = process.env.REACT_APP_BASE_URL;

  useEffect(() => {
    fetchGalleryImages();
  }, [displayLimit, sortOrder, baseUrl]);

  const fetchGalleryImages = async () => {
    try {
      const response = await axios.get(`${baseUrl}/auth/gallery`, {
        params: {
          limit: displayLimit === 0 ? undefined : displayLimit,
          order: sortOrder,
          activeOnly: "true",
        },
      });
      setImages(response.data);
    } catch (error) {
      console.error("Error fetching gallery images:", error);
    }
  };

  const openLightbox = (index) => {
    setPhotoIndex(index);
    setLightboxOpen(true);
  };

  // Prepare slides for lightbox
  const slides = images.map((img) => ({
    src: `${baseUrl}${img.imageUrl}`,
    title: img.title,
    description: img.description,
  }));

  return (
    <ServicesContainer id="gallery">
      <ServicesH1>Gallery</ServicesH1>

      <ControlsBar>
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <ControlLabel>Show:</ControlLabel>
          <Select
            value={displayLimit}
            onChange={(e) => setDisplayLimit(parseInt(e.target.value))}
          >
            <option value={6}>6 Images</option>
            <option value={9}>9 Images</option>
            <option value={12}>12 Images</option>
            <option value={18}>18 Images</option>
            <option value={0}>All Images</option>
          </Select>
        </div>

        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <ControlLabel>Sort:</ControlLabel>
          <Select
            value={sortOrder}
            onChange={(e) => setSortOrder(e.target.value)}
          >
            <option value="ASC">Oldest First</option>
            <option value="DESC">Newest First</option>
          </Select>
        </div>
      </ControlsBar>

      <ServicesWrapper>
        {images.length === 0 ? (
          <div style={{ color: "#fff", fontSize: "1.2rem", gridColumn: "1/-1", textAlign: "center" }}>
            No images in gallery yet
          </div>
        ) : (
          images.map((image, index) => (
            <ImageCard key={image.id} onClick={() => openLightbox(index)}>
              <ServicesIcon
                src={`${baseUrl}${image.imageUrl}`}
                alt={image.title}
                onError={(e) => {
                  e.target.src =
                    "https://via.placeholder.com/300x200/4B5563/FFFFFF?text=Image";
                }}
              />
            </ImageCard>
          ))
        )}
      </ServicesWrapper>

      {/* Lightbox */}
      {lightboxOpen && (
        <Lightbox
          open={lightboxOpen}
          close={() => setLightboxOpen(false)}
          slides={slides}
          index={photoIndex}
        />
      )}
    </ServicesContainer>
  );
};

export default Gallery;
